/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/header.config.json";
import { VApplication } from "../../../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_ROOT_CATEGORIES } from "../graphql";
import _ from "lodash";

const { toKebabCase } = require("js-convert-case");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IHeaderMethods extends IPluginMethodMap {
  getHeaderProps(args: any): Promise<any>;
}

export class HeaderService implements IAgentPlugin {
  readonly methods: IHeaderMethods;

  constructor() {
    this.methods = {
      getHeaderProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    // try {
    //   if (client) {
    //     const res = await client.query({
    //       query: GET_ROOT_CATEGORIES,
    //       variables: {
    //         input: {
    //           criteria: {
    //             parent: null,
    //           },
    //           offset: args?.offset ?? 0,
    //           size: args?.size ?? 10,
    //         },
    //       },
    //       fetchPolicy: "network-only",
    //     });
    //     if (res?.data) {
    //       this.formatNavItems(config, res?.data?.getListOfCategory?.data);
    //       return {
    //         ...(config || {}),
    //       };
    //     }
    //   }
    // } catch (err: any) {
    //   console.log("error in get header service", err?.message);
    //   return {
    //     ...(config || {}),
    //   };
    // }
    return {
      ...(config || {}),
    }
  }

  private formatNavItems(config: any, data: any[]) {
    const found = config?.navItems?.findIndex(
      (o: any) => o.name === "Categories"
    );
    config.navItems[found].children = [];
    for (const category of data) {
      if (found !== -1) {
        config.navItems[found].children?.push({
          icon: "ChevronRight",
          name: category?.name,
          link: `/collection/${category?.uuid}`,
        });
      }
    }
    config.navItems[found].children = _.sortBy(
      config.navItems[found].children,
      "name"
    );
  }
}
